<template>
  <div class="app-wrapper">
    <div v-if="authMode" class="main-container auth-container">
      <div class="header-status" :style="{ background: headerColors[screen] || C.mintDark }">
        <span class="status-time">9:41</span>
        <span class="status-icons">🔋 📶</span>
      </div>

      <div class="auth-scroll-area">
        <div class="auth-header" :style="{ background: `linear-gradient(135deg, ${C.mintDark}, ${C.mint})` }">
          <div class="auth-header-circle"></div>
          <button @click="authMode = null" class="auth-back-btn">‹</button>
          <div class="auth-icon">🩺</div>
          <h2 class="auth-title">PediCheck Ecuador</h2>
          <p class="auth-subtitle">Tu asistente pediátrico gratuito</p>
        </div>

        <div class="auth-content">
          <div :style="cardStyle" class="auth-tabs">
            <button v-for="t in ['register', 'login']" :key="t" 
                    @click="authTab = t; authStep = 1; authErrors = {}" 
                    :style="{ background: authTab === t ? `linear-gradient(135deg, ${C.mint}, ${C.mintDark})` : 'none', color: authTab === t ? C.white : C.slate }"
                    class="auth-tab-btn">
              {{ t === 'register' ? '✨ Crear cuenta' : '🔑 Iniciar sesión' }}
            </button>
          </div>

          <div v-if="authTab === 'register'">
            <div class="step-indicator">
              <div v-for="s in [1, 2]" :key="s" class="step-item" :style="{ flex: s < 2 ? 1 : 'auto' }">
                <div class="step-circle" :style="{ background: authStep >= s ? `linear-gradient(135deg, ${C.mint}, ${C.mintDark})` : C.lightGray, color: authStep >= s ? C.white : C.slate }">{{ s }}</div>
                <span class="step-label" :style="{ color: authStep >= s ? C.navy : C.slate, fontWeight: authStep === s ? 700 : 400 }">{{ s === 1 ? 'Datos personales' : 'Contraseña' }}</span>
                <div v-if="s < 2" class="step-line" :style="{ background: authStep > s ? C.mint : C.lightGray }"></div>
              </div>
            </div>

            <div :style="cardStyle" class="auth-card">
              <template v-if="authStep === 1">
                <p class="auth-section-title">👤 Tus datos</p>
                <div class="input-wrap">
                  <span class="input-icon">👤</span>
                  <input type="text" placeholder="Nombre completo *" v-model="authForm.name" :style="getInputStyle(authErrors.name)" />
                  <p v-if="authErrors.name" class="error-msg">Campo requerido</p>
                </div>
                <div class="input-wrap">
                  <span class="input-icon">📧</span>
                  <input type="email" placeholder="Correo electrónico *" v-model="authForm.email" :style="getInputStyle(authErrors.email)" />
                  <p v-if="authErrors.email" class="error-msg">Campo requerido</p>
                </div>
                <div class="input-wrap">
                  <span class="input-icon">📱</span>
                  <input type="tel" placeholder="Teléfono (opcional)" v-model="authForm.phone" :style="getInputStyle(false)" />
                </div>
              </template>
              <template v-else>
                <p class="auth-section-title">🔐 Crea tu contraseña</p>
                <div class="input-wrap">
                  <span class="input-icon">🔒</span>
                  <input type="password" placeholder="Contraseña *" v-model="authForm.password" :style="getInputStyle(authErrors.password)" />
                  <p v-if="authErrors.password" class="error-msg">Campo requerido</p>
                </div>
                <div class="input-wrap">
                  <span class="input-icon">🔒</span>
                  <input type="password" placeholder="Confirmar contraseña" v-model="authForm.confirmPassword" :style="getInputStyle(false)" />
                </div>
                <div class="free-badge" :style="{ background: C.mintLight }">
                  <p :style="{ color: C.mintDark }">✅ Cuenta 100% gratuita</p>
                  <p :style="{ color: C.slate }">Sin tarjeta de crédito · Sin compromisos</p>
                </div>
              </template>
            </div>
            <button @click="handleRegister" class="primary-btn" :style="{ background: `linear-gradient(135deg, ${C.mint}, ${C.mintDark})`, boxShadow: `0 6px 20px ${C.mint}35` }">
              {{ authStep === 1 ? 'Continuar →' : 'Crear mi cuenta gratis ✨' }}
            </button>
            <button v-if="authStep === 2" @click="authStep = 1" class="text-btn">← Volver</button>
          </div>

          <div v-else>
            <div :style="cardStyle" class="auth-card">
              <p class="auth-section-title">Bienvenida de nuevo 👋</p>
              <div class="input-wrap">
                <span class="input-icon">📧</span>
                <input type="email" placeholder="Correo electrónico" v-model="authForm.email" :style="getInputStyle(authErrors.email)" />
              </div>
              <div class="input-wrap">
                <span class="input-icon">🔒</span>
                <input type="password" placeholder="Contraseña" v-model="authForm.password" :style="getInputStyle(authErrors.password)" />
              </div>
              <button class="forgot-btn" :style="{ color: C.mint }">¿Olvidaste tu contraseña?</button>
            </div>
            <button @click="handleLogin" class="primary-btn" :style="{ background: `linear-gradient(135deg, ${C.mint}, ${C.mintDark})`, boxShadow: `0 6px 20px ${C.mint}35` }">
              Iniciar sesión →
            </button>
          </div>

          <div class="auth-footer">
            <p :style="{ color: C.slate }">Al registrarte aceptas nuestros <span :style="{ color: C.mint }">Términos de uso</span> y <span :style="{ color: C.mint }">Política de privacidad</span>.<br/>PediCheck NO reemplaza la consulta médica profesional.</p>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="main-container">
      
      <div v-if="gateModal" class="gate-overlay" @click="gateModal = null">
        <div class="gate-content" @click.stop :style="{ background: C.white }">
          <div class="gate-handle" :style="{ background: C.lightGray }"></div>
          <div class="gate-text">
            <div class="gate-icon">🔒</div>
            <h3 :style="{ color: C.navy }">Crea tu cuenta gratis</h3>
            <p :style="{ color: C.slate }">{{ gateModalReason }}</p>
          </div>
          <div class="gate-actions">
            <button @click="gateModal = null; authMode = 'register'" class="primary-btn" :style="{ background: `linear-gradient(135deg, ${C.mint}, ${C.mintDark})`, boxShadow: `0 6px 20px ${C.mint}35` }">✨ Crear cuenta gratis</button>
            <button @click="gateModal = null; authMode = 'login'" class="secondary-btn" :style="{ background: C.lightGray, color: C.navy }">Ya tengo cuenta — Iniciar sesión</button>
            <button @click="gateModal = null" class="text-btn" :style="{ color: C.slate }">Seguir explorando sin registrarme</button>
          </div>
        </div>
      </div>

      <div class="status-bar" :style="{ background: headerColors[screen] || C.mintDark }">
        <span class="status-time">9:41</span>
        <span class="status-icons">🔋 📶</span>
      </div>
      <div class="app-bar" :style="{ background: headerColors[screen] || C.mintDark }">
        <div class="app-logo">
          <span class="logo-icon">🩺</span>
          <span class="logo-text" :style="{ color: C.white }">PediCheck <span class="logo-sub">Ecuador</span></span>
        </div>
        <div class="app-badge">
          <span :style="{ color: C.white }">{{ isGuest ? '🔓 Invitado' : '✨ FREE' }}</span>
        </div>
      </div>

      <div class="content-area">
        
        <div v-if="screen === 'home'" class="screen-home">
          <div class="home-hero" :style="{ background: `linear-gradient(135deg, ${C.mintDark}, ${C.mint})` }">
            <div class="hero-circle"></div>
            <div class="hero-header">
              <div>
                <p class="hero-greeting">{{ isGuest ? 'Explorando como invitado 👋' : 'Buenos días 👋' }}</p>
                <h2 class="hero-name" :style="{ color: C.white }">{{ isGuest ? 'Bienvenido' : 'María Fernanda' }}</h2>
              </div>
              <button v-if="isGuest" @click="handleGate('register')" class="hero-btn-guest" :style="{ color: C.white }">Registrarme</button>
              <div v-else class="hero-avatar">👩</div>
            </div>

            <div v-if="isGuest" class="baby-placeholder" @click="handleGate('register')">
              <p class="placeholder-title">👶 Agrega el perfil de tu bebé</p>
              <p class="placeholder-sub">Crea una cuenta gratuita para empezar →</p>
            </div>
            <div v-else class="baby-selector">
              <div v-for="b in babies" :key="b.id" @click="activeBaby = b.id" class="baby-tab" :style="{ background: activeBaby === b.id ? C.white : 'rgba(255,255,255,0.15)', border: activeBaby === b.id ? 'none' : '1.5px solid rgba(255,255,255,0.25)' }">
                <div class="baby-tab-icon">{{ b.avatar }}</div>
                <p class="baby-tab-name" :style="{ color: activeBaby === b.id ? C.navyMid : C.white }">{{ b.name }}</p>
                <p class="baby-tab-age" :style="{ color: activeBaby === b.id ? C.slate : 'rgba(255,255,255,0.8)' }">{{ b.age }}</p>
              </div>
              <div class="baby-add">+</div>
            </div>
          </div>

          <div class="home-content">
            <div :style="[cardStyle, { border: `1.5px solid ${C.mintLight}` }]" class="cta-card" @click="isGuest ? handleGate('chat_ia') : (screen = 'chat')">
              <div class="cta-icon" :style="{ background: `linear-gradient(135deg, ${C.mint}, ${C.mintDark})` }">🤖</div>
              <div class="cta-text">
                <p :style="{ color: C.navy }">Chat IA Pediátrico</p>
                <span :style="{ color: C.slate }">{{ isGuest ? 'Regístrate gratis para usar ·' : 'Disponible 24/7 ·' }} Validado por pediatra</span>
              </div>
              <div class="cta-arrow" :style="{ color: C.mint }">›</div>
            </div>

            <div class="ad-banner" :style="{ background: ads[0].bg, border: `1px solid ${ads[0].border}` }">
              <div class="ad-badge-wrap"><span class="ad-badge" :style="{ color: C.slate }">Anuncio · Contenido patrocinado</span></div>
              <div class="ad-body">
                <div class="ad-emoji" :style="{ border: `1px solid ${ads[0].border}` }">{{ ads[0].emoji }}</div>
                <div class="ad-info">
                  <p :style="{ color: C.navy }">{{ ads[0].brand }}</p>
                  <span :style="{ color: C.slate }">{{ ads[0].tagline }}</span>
                </div>
                <button class="ad-btn" :style="{ background: ads[0].color, boxShadow: `0 4px 12px ${ads[0].color}30` }">{{ ads[0].cta }}</button>
              </div>
            </div>

            <div v-if="!isGuest && nextVac" class="vaccine-alert" :style="{ background: `linear-gradient(135deg, ${C.amberLight}, #FFF3D6)`, border: `1.5px solid ${C.amber}30` }">
              <span class="alert-icon">💉</span>
              <div class="alert-info">
                <p :style="{ color: C.navy }">Próxima vacuna: {{ nextVac.name }}</p>
                <span :style="{ color: C.slate }">A los {{ nextVac.due }} · Pendiente para {{ currentBaby?.name }}</span>
              </div>
            </div>

            <div v-if="!isGuest" class="stats-grid">
              <div v-for="(s, i) in [{l:'Peso',v:currentBaby?.weight,i:'⚖️',c:C.blue},{l:'Talla',v:currentBaby?.height,i:'📏',c:C.purple},{l:'Edad',v:currentBaby?.age,i:'🎂',c:C.coral}]" :key="i" :style="cardStyle" class="stat-card">
                <div class="stat-icon">{{ s.i }}</div>
                <p class="stat-value" :style="{ color: s.c }">{{ s.v }}</p>
                <p class="stat-label" :style="{ color: C.slate }">{{ s.l }}</p>
              </div>
            </div>

            <div :style="[cardStyle, { background: `linear-gradient(135deg, ${C.blueLight}, #E0F2FE)`, border: `1.5px solid ${C.blue}25` }]" class="cta-card" @click="screen = 'centers'">
              <div class="cta-icon" :style="{ background: `linear-gradient(135deg, ${C.blue}, #0284C7)` }">📍</div>
              <div class="cta-text">
                <p :style="{ color: C.navy }">Centros de salud cercanos</p>
                <span :style="{ color: C.slate }">IESS · MSP · Clínicas · Emergencias</span>
              </div>
              <div class="cta-arrow" :style="{ color: C.blue }">›</div>
            </div>

            <h3 class="section-heading" :style="{ color: C.navy }">Herramientas rápidas</h3>
            <div class="tools-grid">
              <div v-for="(t, i) in [{i:'🌡️',t:'Calculadora Fiebre',s:'Gravedad por edad',bg:C.coralLight,c:C.coral,gate:false},{i:'💊',t:'Dosis',s:'Paracetamol por peso',bg:C.purpleLight,c:C.purple,gate:false},{i:'📏',t:'Curvas OMS',s:'Percentiles reales',bg:C.mintLight,c:C.mint,gate:true},{i:'🥣',t:'Alimentación',s:'Guía por edad',bg:C.amberLight,c:C.amber,gate:false}]" 
                   :key="i" :style="[cardStyle, { background: t.bg, border: `1.5px solid ${t.c}20`, padding: '14px', position: 'relative' }]" @click="t.gate && isGuest ? handleGate('curvas_oms') : null" class="tool-card">
                <div v-if="t.gate && isGuest" class="tool-lock">🔒</div>
                <div class="tool-icon">{{ t.i }}</div>
                <p class="tool-title" :style="{ color: C.navy }">{{ t.t }}</p>
                <p class="tool-sub" :style="{ color: C.slate }">{{ t.s }}</p>
              </div>
            </div>

            <div class="ad-compact" :style="{ background: ads[1].bg, border: `1px solid ${ads[1].border}` }">
              <span class="ad-compact-icon">{{ ads[1].emoji }}</span>
              <div class="ad-compact-info">
                <div><span class="ad-compact-badge" :style="{ color: C.slate }">Patrocinado</span></div>
                <p :style="{ color: C.navy }">{{ ads[1].brand }}</p>
                <span :style="{ color: C.slate }">{{ ads[1].tagline }}</span>
              </div>
              <button class="ad-compact-btn" :style="{ background: ads[1].color }">{{ ads[1].cta }}</button>
            </div>

            <h3 class="section-heading" :style="{ color: C.navy, marginTop: '16px' }">Artículos para ti</h3>
            <div class="articles-list">
              <div v-for="(a, i) in [{e:'🌙',t:'Regresión del sueño a los 8 meses',tag:'Sueño',min:'4 min'},{e:'🦷',t:'Dentición: qué esperar y cómo aliviar',tag:'Desarrollo',min:'3 min'}]" :key="i" :style="[cardStyle, { padding: '14px 16px', display: 'flex', gap: '12px', alignItems: 'center' }]" class="article-card">
                <span class="article-icon">{{ a.e }}</span>
                <div class="article-info">
                  <p :style="{ color: C.navy }">{{ a.t }}</p>
                  <div>
                    <span class="article-tag" :style="{ background: C.mintLight, color: C.mintDark }">{{ a.tag }}</span>
                    <span class="article-time" :style="{ color: C.slate }">⏱ {{ a.min }}</span>
                  </div>
                </div>
              </div>

              <div class="ad-banner" :style="{ background: ads[2].bg, border: `1px solid ${ads[2].border}` }">
                <div class="ad-badge-wrap"><span class="ad-badge" :style="{ color: C.slate }">Anuncio · Contenido patrocinado</span></div>
                <div class="ad-body">
                  <div class="ad-emoji" :style="{ border: `1px solid ${ads[2].border}` }">{{ ads[2].emoji }}</div>
                  <div class="ad-info">
                    <p :style="{ color: C.navy }">{{ ads[2].brand }}</p>
                    <span :style="{ color: C.slate }">{{ ads[2].tagline }}</span>
                  </div>
                  <button class="ad-btn" :style="{ background: ads[2].color, boxShadow: `0 4px 12px ${ads[2].color}30` }">{{ ads[2].cta }}</button>
                </div>
              </div>

              <div :style="[cardStyle, { padding: '14px 16px', display: 'flex', gap: '12px', alignItems: 'center' }]" class="article-card">
                <span class="article-icon">🤧</span>
                <div class="article-info">
                  <p :style="{ color: C.navy }">Resfriado en bebés: cuándo ir al médico</p>
                  <div>
                    <span class="article-tag" :style="{ background: C.mintLight, color: C.mintDark }">Síntomas</span>
                    <span class="article-time" :style="{ color: C.slate }">⏱ 5 min</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-else-if="screen === 'chat'" class="screen-chat">
          <template v-if="isGuest">
            <div class="chat-guest-hero" :style="{ background: `linear-gradient(135deg, ${C.mintDark}, ${C.mint})` }">
              <h2 :style="{ color: C.white }">Chat IA Pediátrico</h2>
              <p :style="{ color: 'rgba(255,255,255,0.8)' }">Consultas validadas por pediatra 24/7</p>
            </div>
            <div :style="[cardStyle, { padding: '24px', textAlign: 'center', marginBottom: '14px', margin: '0 16px' }]">
              <div class="chat-guest-icon">🤖</div>
              <h3 :style="{ color: C.navy }">Crea tu cuenta para usar el Chat IA</h3>
              <p :style="{ color: C.slate }">El chat guarda el perfil de tu bebé para darte respuestas personalizadas. Gratis, sin tarjeta.</p>
              <button @click="handleGate('chat_ia')" class="primary-btn" :style="{ background: `linear-gradient(135deg, ${C.mint}, ${C.mintDark})`, boxShadow: `0 6px 20px ${C.mint}35` }">✨ Registrarme gratis</button>
            </div>
          </template>
          
          <template v-else-if="chatActive">
            <div class="chat-active-wrap">
              <div class="chat-header" :style="{ background: `linear-gradient(135deg, ${C.mintDark}, ${C.mint})` }">
                <button @click="chatActive = null" class="auth-back-btn chat-back">‹</button>
                <div class="chat-avatar">{{ currentBaby?.avatar }}</div>
                <div class="chat-header-info">
                  <p :style="{ color: C.white }">{{ currentBaby?.name }} · PediCheck IA</p>
                  <span :style="{ color: 'rgba(255,255,255,0.75)' }">🟢 En línea · {{ 3 - chatMsgCount }} consultas gratis restantes</span>
                </div>
              </div>
              <div class="chat-messages" :style="{ background: C.lightGray }">
                <div v-for="(m, i) in chatMessages" :key="i">
                  <div class="chat-bubble-wrap" :style="{ justifyContent: m.role === 'user' ? 'flex-end' : 'flex-start' }">
                    <div v-if="m.role === 'assistant'" class="chat-bot-icon" :style="{ background: `linear-gradient(135deg, ${C.mint}, ${C.mintDark})` }">🤖</div>
                    <div class="chat-bubble" :style="{ background: m.role === 'user' ? `linear-gradient(135deg, ${C.mint}, ${C.mintDark})` : C.white, color: m.role === 'user' ? C.white : C.navy, borderRadius: m.role === 'user' ? '18px 18px 4px 18px' : '18px 18px 18px 4px' }">
                      {{ m.text.replace(/\*\*/g, "") }}
                    </div>
                  </div>
                  <div v-if="m.role === 'assistant' && i > 0 && i % 4 === 0" class="ad-compact" :style="{ background: ads[i%5].bg, border: `1px solid ${ads[i%5].border}` }">
                    <span class="ad-compact-icon">{{ ads[i%5].emoji }}</span>
                    <div class="ad-compact-info">
                      <div><span class="ad-compact-badge" :style="{ color: C.slate }">Patrocinado</span></div>
                      <p :style="{ color: C.navy }">{{ ads[i%5].brand }}</p>
                      <span :style="{ color: C.slate }">{{ ads[i%5].tagline }}</span>
                    </div>
                    <button class="ad-compact-btn" :style="{ background: ads[i%5].color }">{{ ads[i%5].cta }}</button>
                  </div>
                </div>
                <div v-if="chatLoading" class="chat-bubble-wrap" style="justify-content: flex-start">
                  <div class="chat-bot-icon" :style="{ background: `linear-gradient(135deg, ${C.mint}, ${C.mintDark})` }">🤖</div>
                  <div class="chat-bubble typing" :style="{ background: C.white }">
                    <div v-for="i in 3" :key="i" class="typing-dot" :style="{ background: C.mint, animationDelay: `${(i-1)*0.15}s` }"></div>
                  </div>
                </div>
                <div ref="messagesEndRef"></div>
              </div>
              <div class="chat-input-area" :style="{ background: C.white, borderTop: `1px solid ${C.lightGray}` }">
                <input v-model="chatInput" @keydown.enter="sendMessage" :placeholder="`Consultar sobre ${currentBaby?.name}...`" :style="{ background: C.lightGray, color: C.navy, border: `1.5px solid ${C.lightGray}` }" />
                <button @click="sendMessage" :disabled="!chatInput.trim() || chatLoading" :style="{ background: chatInput.trim() ? `linear-gradient(135deg, ${C.mint}, ${C.mintDark})` : C.lightGray, color: C.white }">➤</button>
              </div>
            </div>
          </template>

          <template v-else>
            <div class="chat-history-hero" :style="{ background: `linear-gradient(135deg, ${C.mintDark}, ${C.mint})` }">
              <h2 :style="{ color: C.white }">Consultas IA</h2>
              <p :style="{ color: 'rgba(255,255,255,0.8)' }">Historial de {{ currentBaby?.name }} · {{ activeChatHistory.length }} conversaciones</p>
            </div>
            <div class="chat-history-content">
              <button @click="openChat({id: 'new'})" class="primary-btn" :style="{ background: `linear-gradient(135deg, ${C.mint}, ${C.mintDark})`, boxShadow: `0 8px 24px ${C.mint}40` }">
                <span style="font-size: 20px">✨</span> Nueva consulta para {{ currentBaby?.name }}
              </button>
              
              <div class="ad-compact" :style="{ background: ads[3].bg, border: `1px solid ${ads[3].border}` }">
                <span class="ad-compact-icon">{{ ads[3].emoji }}</span>
                <div class="ad-compact-info">
                  <div><span class="ad-compact-badge" :style="{ color: C.slate }">Patrocinado</span></div>
                  <p :style="{ color: C.navy }">{{ ads[3].brand }}</p>
                  <span :style="{ color: C.slate }">{{ ads[3].tagline }}</span>
                </div>
                <button class="ad-compact-btn" :style="{ background: ads[3].color }">{{ ads[3].cta }}</button>
              </div>

              <h3 class="section-heading" :style="{ color: C.navy }">Historial guardado</h3>
              <div class="history-list">
                <div v-for="chat in activeChatHistory" :key="chat.id" @click="openChat(chat)" :style="[cardStyle, { padding: '14px 16px', border: chat.urgent ? `1.5px solid ${C.coral}40` : '1px solid transparent' }]" class="history-card">
                  <div class="history-card-header">
                    <span :style="{ background: chat.urgent ? C.coralLight : C.mintLight, color: chat.urgent ? C.coral : C.mintDark }">{{ chat.tag }}</span>
                    <span :style="{ color: C.slate }">{{ chat.date }}</span>
                  </div>
                  <p :style="{ color: C.navy }">{{ chat.title }}</p>
                </div>
              </div>
            </div>
          </template>
        </div>

        <div v-else-if="screen === 'vaccines'" class="screen-vaccines">
          <div class="vac-hero" :style="{ background: `linear-gradient(135deg, ${C.purple}, #6D28D9)` }">
            <h2 :style="{ color: C.white }">Vacunas · {{ currentBaby?.name }}</h2>
            <p :style="{ color: 'rgba(255,255,255,0.8)' }">Esquema MSP Ecuador</p>
            <div class="vac-stats">
              <div class="vac-stat">
                <p :style="{ color: C.white }">{{ doneVaccines }}</p>
                <span :style="{ color: 'rgba(255,255,255,0.8)' }">Aplicadas</span>
              </div>
              <div class="vac-stat">
                <p :style="{ color: C.white }">{{ vaccines.length - doneVaccines }}</p>
                <span :style="{ color: 'rgba(255,255,255,0.8)' }">Pendientes</span>
              </div>
              <div class="vac-progress-wrap">
                <div class="vac-bar-bg"><div class="vac-bar-fill" :style="{ width: `${Math.round(doneVaccines/vaccines.length*100)}%`, background: C.white }"></div></div>
                <p :style="{ color: 'rgba(255,255,255,0.8)' }">{{ Math.round(doneVaccines/vaccines.length*100) }}% completado</p>
              </div>
            </div>
          </div>
          <div class="vac-list">
            <div class="ad-compact" :style="{ background: ads[0].bg, border: `1px solid ${ads[0].border}` }">
              <span class="ad-compact-icon">{{ ads[0].emoji }}</span>
              <div class="ad-compact-info">
                <div><span class="ad-compact-badge" :style="{ color: C.slate }">Patrocinado</span></div>
                <p :style="{ color: C.navy }">{{ ads[0].brand }}</p>
                <span :style="{ color: C.slate }">{{ ads[0].tagline }}</span>
              </div>
              <button class="ad-compact-btn" :style="{ background: ads[0].color }">{{ ads[0].cta }}</button>
            </div>
            
            <div v-for="(v, i) in vaccines" :key="i" :style="[cardStyle, { padding: '14px 16px', display: 'flex', alignItems: 'center', gap: '14px', border: v.upcoming ? `1.5px solid ${C.amber}` : '1.5px solid transparent' }]">
              <div class="vac-icon" :style="{ background: v.done ? C.mintLight : v.upcoming ? C.amberLight : C.lightGray }">{{ v.done ? '✅' : v.upcoming ? '⏰' : '💉' }}</div>
              <div class="vac-info">
                <p :style="{ color: C.navy }">{{ v.name }}</p>
                <span :style="{ color: C.slate }">A los {{ v.due }} · {{ v.done ? `Aplicada: ${v.date}` : v.upcoming ? '¡Próximamente!' : 'Pendiente' }}</span>
              </div>
              <span v-if="v.upcoming" class="vac-badge" :style="{ background: C.amberLight, color: C.amber }">PRÓXIMA</span>
            </div>
          </div>
        </div>

        <div v-else-if="screen === 'centers'" class="screen-centers">
          <template v-if="centersSelected">
            <div class="centers-detail">
              <div class="center-map-mock" :style="{ background: 'linear-gradient(135deg,#DBEAFE,#EDE9FE)' }">
                <div class="center-marker-wrap">
                  <div class="center-marker-pin" :style="{ background: centersSelected.color, boxShadow: `0 4px 16px ${centersSelected.color}60` }">
                    <span class="center-marker-icon">{{ centersSelected.emoji }}</span>
                  </div>
                  <div class="center-marker-label" :style="{ color: C.navy }">{{ centersSelected.name.split(' ').slice(0,2).join(' ') }}</div>
                </div>
                <div class="center-user-dot" :style="{ background: C.blue }"></div>
                <button @click="centersSelected = null" class="center-back-btn" :style="{ color: C.navy }">‹</button>
                <div class="center-dist-badge" :style="{ color: C.blue }">📍 {{ centersSelected.distance }}</div>
              </div>
              <div class="center-info-area">
                <div :style="cardStyle" class="center-main-card">
                  <div class="center-main-header">
                    <div class="center-icon" :style="{ background: `${centersSelected.color}15`, border: `2px solid ${centersSelected.color}30` }">{{ centersSelected.emoji }}</div>
                    <div class="center-title-area">
                      <div class="center-tags">
                        <span class="c-tag" :style="{ background: `${centersSelected.color}15`, color: centersSelected.color }">{{ centersSelected.typeLabel }}</span>
                        <span v-if="centersSelected.emergency" class="c-tag" :style="{ background: C.coralLight, color: C.coral }">🚨 24h</span>
                      </div>
                      <h3 :style="{ color: C.navy }">{{ centersSelected.name }}</h3>
                      <p :style="{ color: C.slate }">📌 {{ centersSelected.address }}</p>
                    </div>
                  </div>
                </div>
                
                <div class="center-stats-grid">
                  <div v-for="(s, i) in [{i:'⏱️',l:'Tiempo',v:centersSelected.time},{i:'📏',l:'Distancia',v:centersSelected.distance},{i:'🕐',l:'Horario',v:centersSelected.hours},{i:'⭐',l:'Valoración',v:`${centersSelected.rating}/5`}]" :key="i" :style="cardStyle" class="c-stat-card">
                    <span class="c-stat-icon">{{ s.i }}</span>
                    <div>
                      <p class="c-stat-label" :style="{ color: C.slate }">{{ s.l }}</p>
                      <p class="c-stat-val" :style="{ color: C.navy }">{{ s.v }}</p>
                    </div>
                  </div>
                </div>

                <div :style="cardStyle" class="center-services-card">
                  <p class="c-srv-title" :style="{ color: C.navy }">Servicios disponibles</p>
                  <div class="c-srv-list">
                    <span v-for="(s, i) in centersSelected.services" :key="i" class="c-srv-item" :style="{ background: C.mintLight, color: C.mintDark, border: `1px solid ${C.mint}30` }">✓ {{ s }}</span>
                  </div>
                </div>

                <div class="ad-banner" :style="{ background: ads[2].bg, border: `1px solid ${ads[2].border}` }">
                  <div class="ad-badge-wrap"><span class="ad-badge" :style="{ color: C.slate }">Anuncio · Contenido patrocinado</span></div>
                  <div class="ad-body">
                    <div class="ad-emoji" :style="{ border: `1px solid ${ads[2].border}` }">{{ ads[2].emoji }}</div>
                    <div class="ad-info">
                      <p :style="{ color: C.navy }">{{ ads[2].brand }}</p>
                      <span :style="{ color: C.slate }">{{ ads[2].tagline }}</span>
                    </div>
                    <button class="ad-btn" :style="{ background: ads[2].color, boxShadow: `0 4px 12px ${ads[2].color}30` }">{{ ads[2].cta }}</button>
                  </div>
                </div>

                <div class="center-actions">
                  <a :href="`tel:${centersSelected.phone}`" class="c-btn-call" :style="{ background: `linear-gradient(135deg, ${C.mint}, ${C.mintDark})`, boxShadow: `0 6px 20px ${C.mint}35` }">📞 Llamar</a>
                  <button class="c-btn-map" :style="{ background: C.blueLight, border: `1.5px solid ${C.blue}30`, color: C.blue }">🗺️ Cómo llegar</button>
                </div>
              </div>
            </div>
          </template>
          
          <template v-else>
            <div class="centers-hero" :style="{ background: `linear-gradient(135deg, #0284C7, ${C.blue})` }">
              <h2 :style="{ color: C.white }">Centros de Salud</h2>
              <p :style="{ color: 'rgba(255,255,255,0.8)' }">📍 Cerca de ti · Quito, Ecuador</p>
            </div>
            <div class="centers-list-area">
              <div :style="cardStyle" class="c-map-mock-small">
                 <div class="c-user-dot" :style="{ background: C.blue }"></div>
                 <div class="c-user-label" :style="{ color: C.blue }">📍 Tú estás aquí</div>
              </div>

              <div class="c-emergencies" :style="{ background: `linear-gradient(135deg, ${C.coralLight}, #FFE4E4)`, border: `1.5px solid ${C.coral}30` }">
                <p class="c-emerg-title" :style="{ color: C.navy }">🚨 Emergencias 24h</p>
                <div v-for="c in healthCenters.filter(c => c.emergency)" :key="c.id" @click="centersSelected = c" class="c-emerg-item">
                  <span :style="{ color: C.navyMid }">{{ c.emoji }} {{ c.name.split(' ').slice(0,3).join(' ') }}</span>
                  <span :style="{ color: C.coral }">{{ c.distance }} ›</span>
                </div>
              </div>

              <div class="c-filters">
                <button v-for="f in centersFilters" :key="f.id" @click="centersFilter = f.id" class="c-filter-btn" :style="{ background: centersFilter === f.id ? `linear-gradient(135deg, ${C.blue}, #0284C7)` : C.white, border: centersFilter === f.id ? 'none' : `1.5px solid ${C.lightGray}`, color: centersFilter === f.id ? C.white : C.slate, boxShadow: centersFilter === f.id ? `0 4px 12px ${C.blue}30` : 'none' }">
                  {{ f.e }} {{ f.label }}
                </button>
              </div>

              <div class="c-list">
                <div v-for="(c, idx) in filteredCenters" :key="c.id">
                  <div :style="cardStyle" class="c-list-item" @click="centersSelected = c">
                    <div class="c-list-header">
                      <div class="c-list-icon" :style="{ background: `${c.color}15`, border: `1.5px solid ${c.color}30` }">{{ c.emoji }}</div>
                      <div class="c-list-info">
                        <div class="c-list-title-row">
                          <p :style="{ color: C.navy }">{{ c.name }}</p>
                          <div class="c-list-dist">
                            <span :style="{ color: C.blue }">{{ c.distance }}</span>
                            <span :style="{ color: C.slate }">{{ c.time }}</span>
                          </div>
                        </div>
                        <p class="c-list-address" :style="{ color: C.slate }">{{ c.address }}</p>
                        <div class="c-list-tags">
                          <span :style="{ background: `${c.color}15`, color: c.color }">{{ c.typeLabel }}</span>
                          <span v-if="c.emergency" :style="{ background: C.coralLight, color: C.coral }">🚨 24h</span>
                          <span class="c-list-rating" :style="{ color: C.slate }">⭐ {{ c.rating }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="c-list-actions" :style="{ borderTop: `1px solid ${C.lightGray}` }">
                      <div class="c-list-btn" :style="{ background: C.mintLight, color: C.mintDark }">📞 Llamar</div>
                      <div class="c-list-btn" :style="{ background: C.blueLight, color: C.blue }">🗺️ Cómo llegar</div>
                    </div>
                  </div>

                  <div v-if="idx === 1" class="ad-compact" :style="{ background: ads[4].bg, border: `1px solid ${ads[4].border}`, margin: '12px 0' }">
                    <span class="ad-compact-icon">{{ ads[4].emoji }}</span>
                    <div class="ad-compact-info">
                      <div><span class="ad-compact-badge" :style="{ color: C.slate }">Patrocinado</span></div>
                      <p :style="{ color: C.navy }">{{ ads[4].brand }}</p>
                      <span :style="{ color: C.slate }">{{ ads[4].tagline }}</span>
                    </div>
                    <button class="ad-compact-btn" :style="{ background: ads[4].color }">{{ ads[4].cta }}</button>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>

        <div v-else-if="screen === 'profile'" class="screen-profile">
          <template v-if="isGuest">
            <div class="prof-guest-hero" :style="{ background: `linear-gradient(135deg, ${C.navyMid}, ${C.navy})` }">
              <div class="prof-guest-icon">👤</div>
              <h2 :style="{ color: C.white }">Explorando sin cuenta</h2>
              <p :style="{ color: 'rgba(255,255,255,0.7)' }">Crea tu cuenta gratis para guardar el historial de tu bebé</p>
            </div>
            <div class="prof-guest-content">
              <div :style="cardStyle" class="prof-upsell-card">
                <p :style="{ color: C.navy }">¿Qué te pierdes sin cuenta?</p>
                <div v-for="(f, i) in ['Historial de conversaciones con IA', 'Perfil completo de tus hijos', 'Recordatorios de vacunas', 'Seguimiento de crecimiento', 'Acceso en múltiples dispositivos']" :key="i" class="prof-upsell-item">
                  <span class="prof-check" :style="{ background: C.mintLight, color: C.mintDark }">✓</span>
                  <span :style="{ color: C.navyMid }">{{ f }}</span>
                </div>
              </div>
              <button @click="authMode = 'register'" class="primary-btn" :style="{ background: `linear-gradient(135deg, ${C.mint}, ${C.mintDark})`, boxShadow: `0 6px 20px ${C.mint}35`, marginBottom: '10px' }">✨ Crear cuenta gratis</button>
              <button @click="authMode = 'login'" class="secondary-btn" :style="{ background: C.lightGray, color: C.navy }">Ya tengo cuenta</button>
            </div>
          </template>
          
          <template v-else>
            <div class="prof-hero" :style="{ background: `linear-gradient(135deg, ${C.navyMid}, ${C.navy})` }">
              <div class="prof-hero-circle"></div>
              <div class="prof-hero-main">
                <div class="prof-avatar" :style="{ background: `linear-gradient(135deg, ${C.mint}, ${C.mintDark})` }">👩</div>
                <div class="prof-hero-info">
                  <h2 :style="{ color: C.white }">{{ profileData.name }}</h2>
                  <p :style="{ color: 'rgba(255,255,255,0.7)' }">{{ profileData.email }}</p>
                  <div class="prof-hero-tags">
                    <span class="p-tag-free">✨ Plan Gratuito</span>
                    <span class="p-tag-role" :style="{ background: `${C.mint}30` }">{{ profileData.role }}</span>
                  </div>
                </div>
                <button @click="profileEditing = !profileEditing" class="prof-edit-btn">{{ profileEditing ? 'Cancelar' : '✏️ Editar' }}</button>
              </div>
            </div>

            <div class="prof-content">
              <div class="prof-premium-card" :style="{ background: `linear-gradient(135deg, #1A2E4A, #2D4A6B)` }">
                <span class="p-prem-icon">👑</span>
                <div class="p-prem-info">
                  <p :style="{ color: C.white }">Actualizar a Premium</p>
                  <span :style="{ color: 'rgba(255,255,255,0.6)' }">Sin anuncios · Todo ilimitado · $4.99/mes</span>
                </div>
                <button class="p-prem-btn" :style="{ background: `linear-gradient(135deg, ${C.amber}, #F59E0B)` }">Ver plan</button>
              </div>

              <div :style="cardStyle" class="prof-section-card">
                <p class="prof-section-title" :style="{ color: C.navy }">👤 Información personal</p>
                <div v-for="f in [{label:'Nombre completo',key:'name',icon:'👤',type:'text'},{label:'Correo electrónico',key:'email',icon:'📧',type:'email'},{label:'Teléfono',key:'phone',icon:'📱',type:'tel'},{label:'Ciudad',key:'city',icon:'📍',type:'text'},{label:'Rol',key:'role',icon:'👩',type:'text'}]" :key="f.key" class="prof-field">
                  <label :style="{ color: C.slate }">{{ f.icon }} {{ f.label }}</label>
                  <input v-if="profileEditing" :type="f.type" v-model="profileData[f.key]" :style="{ border: `1.5px solid ${C.mint}`, background: C.mintLight, color: C.navy }" class="prof-input" />
                  <p v-else class="prof-val" :style="{ color: C.navy, borderBottom: `1px solid ${C.lightGray}` }">{{ profileData[f.key] }}</p>
                </div>
                <button v-if="profileEditing" @click="profileEditing = false" class="primary-btn" :style="{ background: `linear-gradient(135deg, ${C.mint}, ${C.mintDark})`, boxShadow: `0 4px 16px ${C.mint}35`, marginTop: '8px' }">Guardar cambios ✓</button>
              </div>

              <div :style="cardStyle" class="prof-section-card">
                <p class="prof-section-title" :style="{ color: C.navy }">🔔 Preferencias</p>
                <div v-for="pref in [{key:'notifications',label:'Recordatorios de vacunas',sub:'Alertas automáticas por fecha'},{key:'newsletter',label:'Consejos semanales',sub:'Artículos personalizados por edad'}]" :key="pref.key" class="prof-pref-item">
                  <div class="prof-pref-info">
                    <p :style="{ color: C.navy }">{{ pref.label }}</p>
                    <span :style="{ color: C.slate }">{{ pref.sub }}</span>
                  </div>
                  <div class="toggle-switch" @click="profileData[pref.key] = !profileData[pref.key]" :style="{ background: profileData[pref.key] ? C.mint : C.lightGray, border: `2px solid ${profileData[pref.key] ? C.mintDark : '#CBD5E1'}` }">
                    <div class="toggle-knob" :style="{ left: profileData[pref.key] ? '20px' : '2px' }"></div>
                  </div>
                </div>
              </div>

              <div :style="cardStyle" class="prof-actions-card">
                <div v-for="(item, i) in [{icon:'🔐',label:'Cambiar contraseña',color:C.navy},{icon:'📊',label:'Mis datos y privacidad',color:C.navy},{icon:'❓',label:'Centro de ayuda',color:C.navy},{icon:'⭐',label:'Calificar la app',color:C.amber}]" :key="i" class="prof-action-item" :style="{ borderBottom: i < 3 ? `1px solid ${C.lightGray}` : 'none' }">
                  <span class="pa-icon">{{ item.icon }}</span>
                  <span class="pa-label" :style="{ color: item.color }">{{ item.label }}</span>
                  <span class="pa-arrow" :style="{ color: C.slate }">›</span>
                </div>
              </div>

              <button @click="handleLogout" class="logout-btn" :style="{ background: C.coralLight, border: `1.5px solid ${C.coral}30`, color: C.coral }">Cerrar sesión</button>
            </div>
          </template>
        </div>

      </div>

      <div class="bottom-nav" :style="{ background: C.white, borderTop: `1px solid ${C.lightGray}` }">
        <button v-for="t in tabs" :key="t.id" @click="screen = t.id" class="nav-btn">
          <span class="nav-icon" :style="{ fontSize: screen === t.id ? '24px' : '20px' }">{{ t.icon }}</span>
          <span class="nav-label" :style="{ color: screen === t.id ? C.mint : C.slate, fontWeight: screen === t.id ? 700 : 500 }">{{ t.label }}</span>
          <div v-if="screen === t.id" class="nav-indicator" :style="{ background: C.mint }"></div>
        </button>
      </div>

    </div>
  </div>
</template>

<script setup>
import { ref, reactive, computed, nextTick } from 'vue';

/* ── DESIGN TOKENS & MOCK DATA ──────────────────────────────── */
const C = {
  mint: "#3DBFA0", mintLight: "#E8F8F4", mintDark: "#2A9C82",
  coral: "#FF6B6B", coralLight: "#FFF0F0",
  amber: "#FFB347", amberLight: "#FFF8EE",
  navy: "#1A2E4A", navyMid: "#2D4A6B", slate: "#64748B",
  lightGray: "#F4F7FA", white: "#FFFFFF",
  purple: "#8B5CF6", purpleLight: "#F3EEFF",
  blue: "#3B82F6", blueLight: "#EFF6FF",
  adBg: "#FFF9F0", adBorder: "#FFE4B5",
};

const babies = [
  {id:1,name:"Mateo",age:"8 meses",avatar:"👶",weight:"8.2kg",height:"70cm",sex:"M"},
  {id:2,name:"Valentina",age:"2 años 3m",avatar:"👧",weight:"12.1kg",height:"88cm",sex:"F"},
];

const chatHistories = {
  1: [
    {id:1,date:"Hoy, 09:14",title:"Fiebre 38.5°C después de vacuna",tag:"🌡️ Síntomas",urgent:false},
    {id:2,date:"Ayer, 22:31",title:"No quiere papilla de zapallo",tag:"🥣 Alimentación",urgent:false},
    {id:3,date:"12 ene, 03:15",title:"Llanto inconsolable — cólico",tag:"😢 Síntomas",urgent:true},
  ],
  2: [
    {id:4,date:"Hace 3 días",title:"Tos con flema por 2 días",tag:"🤧 Síntomas",urgent:true},
    {id:5,date:"Hace 1 semana",title:"¿Cuándo empezar el cepillado?",tag:"🦷 Desarrollo",urgent:false},
  ],
};

const vaccines = [
  {name:"BCG",due:"Al nacer",done:true,date:"15 Jul 2024"},
  {name:"Hepatitis B",due:"Al nacer",done:true,date:"15 Jul 2024"},
  {name:"Pentavalente 1ra",due:"2 meses",done:true,date:"15 Sep 2024"},
  {name:"Rotavirus 1ra",due:"2 meses",done:true,date:"15 Sep 2024"},
  {name:"Pentavalente 2da",due:"4 meses",done:true,date:"15 Nov 2024"},
  {name:"SRP",due:"12 meses",done:false,upcoming:true},
  {name:"Varicela",due:"12 meses",done:false},
  {name:"Fiebre Amarilla",due:"12 meses",done:false},
];

const healthCenters = [
  {id:1,name:"Hospital Pediátrico Baca Ortiz",type:"hospital",typeLabel:"Hospital Público",emergency:true,address:"Av. 6 de Diciembre y Colón",distance:"1.2 km",time:"5 min",phone:"02-2595-029",hours:"24 horas",rating:4.3,services:["Pediatría","Emergencias","Vacunación"],color:C.coral,emoji:"🏥"},
  {id:2,name:"Centro de Salud Nº1 MSP",type:"msp",typeLabel:"Centro MSP",emergency:false,address:"Mideros y Manabí, Centro Histórico",distance:"2.1 km",time:"8 min",phone:"02-2287-499",hours:"Lun–Vie 7:00–19:00",rating:3.9,services:["Medicina General","Vacunación","Control Niño Sano"],color:C.mint,emoji:"🏪"},
  {id:3,name:"Clínica San Francisco",type:"private",typeLabel:"Clínica Privada",emergency:true,address:"Av. América N32-76, La Paz",distance:"3.4 km",time:"12 min",phone:"02-2553-700",hours:"24 horas",rating:4.7,services:["Pediatría","Emergencias","Laboratorio"],color:C.purple,emoji:"🏨"},
  {id:4,name:"Hospital IESS Quito Sur",type:"iess",typeLabel:"IESS",emergency:true,address:"Mariana de Jesús y Occidental",distance:"5.2 km",time:"18 min",phone:"02-3985-000",hours:"24 horas",rating:3.8,services:["Pediatría","Emergencias","Vacunación"],color:C.amber,emoji:"🏗️"},
];

const ads = [
  {id:1,brand:"Farmacia Cruz Azul",tagline:"Tu farmacia de confianza · Delivery 24h",emoji:"💊",cta:"Ver ofertas",color:"#2563EB",bg:"#EFF6FF",border:"#BFDBFE",badge:"Patrocinado"},
  {id:2,brand:"Nestlé NAN",tagline:"Fórmula infantil · Del nacimiento a los 12 meses",emoji:"🍼",cta:"Saber más",color:"#D97706",bg:"#FFFBEB",border:"#FDE68A",badge:"Patrocinado"},
  {id:3,brand:"Clínica Los Valles",tagline:"Pediatría especializada · Quito · Citas online",emoji:"🏥",cta:"Agendar cita",color:"#059669",bg:"#ECFDF5",border:"#A7F3D0",badge:"Patrocinado"},
  {id:4,brand:"Johnson's Baby",tagline:"Cuidado suave para tu bebé · 100% seguro",emoji:"🛁",cta:"Ver productos",color:"#DB2777",bg:"#FDF2F8",border:"#FBCFE8",badge:"Patrocinado"},
  {id:5,brand:"Farmacias Fybeca",tagline:"Descuentos en pañales y accesorios para bebé",emoji:"🧸",cta:"Ver descuentos",color:C.purple,bg:C.purpleLight,border:"#DDD6FE",badge:"Patrocinado"},
];

/* ── STATE & HELPERS ────────────────────────────────────────── */
const screen = ref('home');
const activeBaby = ref(1);
const user = ref(null); 
const authMode = ref(null); 
const gateModal = ref(null); 

const isGuest = computed(() => !user.value);
const currentBaby = computed(() => babies.find(b => b.id === activeBaby.value));

const headerColors = { home: C.mintDark, chat: C.mintDark, vaccines: "#6D28D9", dev: C.navyMid, centers: "#0284C7", profile: C.navyMid };
const tabs = computed(() => [
  { id: "home", icon: "🏠", label: "Inicio" },
  { id: "chat", icon: "🤖", label: "Chat IA" },
  { id: "vaccines", icon: "💉", label: "Vacunas" },
  { id: "centers", icon: "📍", label: "Centros" },
  { id: "profile", icon: isGuest.value ? "👤" : "👩", label: isGuest.value ? "Cuenta" : "Perfil" },
]);

const cardStyle = {
  background: C.white,
  borderRadius: '20px',
  boxShadow: '0 4px 16px rgba(26,46,74,0.08)',
  border: `1px solid ${C.lightGray}`,
  overflow: 'hidden'
};

/* ── GATE MODAL LOGIC ───────────────────────────────────────── */
const gateModalReason = ref("");
const handleGate = (context) => {
  const reasons = {
    chat_ia: "Para consultar con la IA pediátrica necesitas una cuenta gratuita. Así podremos personalizar las respuestas con el perfil de tu bebé.",
    chat_limite: "Has alcanzado el límite de 3 consultas gratuitas. Crea una cuenta para guardar tu historial y obtener más consultas.",
    curvas_oms: "Las curvas de crecimiento personalizadas requieren el perfil de tu bebé. ¡Regístrate gratis!",
    registro: "Guarda el historial de tu bebé, vacunas y más con una cuenta gratuita.",
  };
  gateModalReason.value = reasons[context] || reasons.registro;
  gateModal.value = true;
};

/* ── AUTH LOGIC ─────────────────────────────────────────────── */
const authTab = ref('register');
const authStep = ref(1);
const authErrors = reactive({});
const authForm = reactive({ name: "", email: "", phone: "", password: "", confirmPassword: "" });

const getInputStyle = (isError) => ({
  width: "100%", border: `1.5px solid ${isError ? C.coral : C.lightGray}`, borderRadius: '14px',
  padding: "13px 14px 13px 42px", fontSize: '14px', outline: "none",
  background: isError ? C.coralLight : C.lightGray, color: C.navy,
  fontFamily: "'Nunito', sans-serif", boxSizing: "border-box", transition: "all 0.2s"
});

const handleRegister = () => {
  if (authTab.value === "register" && authStep.value === 1) {
    authErrors.name = !authForm.name;
    authErrors.email = !authForm.email;
    if (authErrors.name || authErrors.email) return;
    authStep.value = 2; 
    Object.keys(authErrors).forEach(k => delete authErrors[k]);
  } else {
    user.value = { name: authForm.name || "María Fernanda", email: authForm.email || "maria@gmail.com" };
    authMode.value = null;
  }
};

const handleLogin = () => {
  authErrors.email = !authForm.email;
  authErrors.password = !authForm.password;
  if (authErrors.email || authErrors.password) return;
  user.value = { name: "María Fernanda", email: authForm.email };
  authMode.value = null;
};

/* ── HOME & VACCINES LOGIC ──────────────────────────────────── */
const nextVac = computed(() => vaccines.find(v => !v.done));
const doneVaccines = computed(() => vaccines.filter(v => v.done).length);

/* ── CHAT LOGIC ─────────────────────────────────────────────── */
const activeChatHistory = computed(() => chatHistories[activeBaby.value] || []);
const chatActive = ref(null);
const chatMessages = ref([]);
const chatInput = ref("");
const chatLoading = ref(false);
const chatMsgCount = ref(0);
const messagesEndRef = ref(null);

const openChat = (chat) => {
  chatActive.value = chat;
  chatMessages.value = [{ role: "assistant", text: `Hola 👋 Soy PediCheck. Veo el perfil de **${currentBaby.value?.name}** (${currentBaby.value?.age}, ${currentBaby.value?.weight}). ¿En qué te ayudo?` }];
};

const sendMessage = async () => {
  if (!chatInput.value.trim() || chatLoading.value) return;
  const FREE_LIMIT = 3;
  if (chatMsgCount.value >= FREE_LIMIT) {
    handleGate("chat_limite");
    return;
  }
  const userMsg = chatInput.value.trim();
  chatInput.value = "";
  chatMessages.value.push({ role: "user", text: userMsg });
  chatLoading.value = true;
  chatMsgCount.value++;
  
  try {
    const res = await fetch("https://api.anthropic.com/v1/messages", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        model: "claude-sonnet-4-20250514",
        max_tokens: 1000,
        system: `Eres PediCheck, asistente pediátrico IA para padres ecuatorianos. Perfil: ${currentBaby.value?.name}, ${currentBaby.value?.age}, ${currentBaby.value?.weight}. Responde en español, cálido y empático. Para síntomas: 🟢 En casa / 🟡 Llamar médico / 🔴 Urgencias. Máx 120 palabras.`,
        messages: [...chatMessages.value.map(m => ({ role: m.role === "assistant" ? "assistant" : "user", content: m.text })), { role: "user", content: userMsg }]
      })
    });
    const data = await res.json();
    chatMessages.value.push({ role: "assistant", text: data.content?.[0]?.text || "Error." });
  } catch {
    // Simular respuesta si falla la API (comportamiento esperado del mock)
    setTimeout(() => {
      chatMessages.value.push({ role: "assistant", text: "Es importante mantenerlo hidratado. Si la fiebre persiste más de 2 días, por favor acude a tu centro de salud más cercano." });
      chatLoading.value = false;
      scrollToBottom();
    }, 1500);
    return;
  }
  chatLoading.value = false;
  scrollToBottom();
};

const scrollToBottom = () => {
  nextTick(() => {
    messagesEndRef.value?.scrollIntoView({ behavior: "smooth" });
  });
};

/* ── CENTERS LOGIC ──────────────────────────────────────────── */
const centersFilter = ref("all");
const centersSelected = ref(null);
const centersFilters = [
  {id:"all",label:"Todos",e:"📍"}, {id:"hospital",label:"Hospitales",e:"🏥"},
  {id:"msp",label:"MSP",e:"🏪"}, {id:"iess",label:"IESS",e:"🏗️"}, {id:"private",label:"Privados",e:"🏨"}
];
const filteredCenters = computed(() => centersFilter.value === "all" ? healthCenters : healthCenters.filter(c => c.type === centersFilter.value));

/* ── PROFILE LOGIC ──────────────────────────────────────────── */
const profileEditing = ref(false);
const profileData = reactive({
  name: "", email: "", phone: "0987654321",
  city: "Quito", role: "Mamá", notifications: true, newsletter: false,
});

const handleLogout = () => {
  user.value = null;
  screen.value = "home";
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Nunito:wght@400;500;600;700;800&display=swap');

/* GLOBAL RESETS & WRAPPERS */
.app-wrapper {
  font-family: 'Nunito', 'Segoe UI', sans-serif;
  background: #F4F7FA;
  min-height: 100vh;
  max-width: 420px;
  margin: 0 auto;
  box-shadow: 0 0 60px rgba(0,0,0,0.15);
  overflow: hidden;
  position: relative;
}

.main-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.auth-container {
  overflow-y: auto;
}

/* HEADER / APP BAR */
.status-bar {
  padding: 8px 20px 4px;
  display: flex;
  justify-content: space-between;
  position: sticky;
  top: 0;
  z-index: 50;
}
.status-time { color: rgba(255,255,255,0.9); font-size: 11px; font-weight: 600; }
.status-icons { color: rgba(255,255,255,0.9); font-size: 11px; }

.app-bar {
  padding: 4px 20px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: 27px;
  z-index: 50;
}
.app-logo { display: flex; align-items: center; gap: 8px; }
.logo-icon { font-size: 22px; }
.logo-text { font-weight: 800; font-size: 17px; letter-spacing: -0.3px; }
.logo-sub { font-weight: 400; opacity: 0.7; font-size: 13px; }
.app-badge { background: rgba(255,255,255,0.2); border-radius: 20px; padding: 4px 12px; font-size: 11px; font-weight: 700; }

.content-area {
  flex: 1;
  overflow-y: auto;
  height: calc(100dvh - 130px);
}

/* COMMON UI ELEMENTS */
.primary-btn { width: 100%; border: none; border-radius: 16px; padding: 16px; color: #fff; font-weight: 700; font-size: 15px; cursor: pointer; font-family: 'Nunito', sans-serif; }
.secondary-btn { width: 100%; border: none; border-radius: 16px; padding: 16px; font-weight: 700; font-size: 15px; cursor: pointer; font-family: 'Nunito', sans-serif; }
.text-btn { width: 100%; background: none; border: none; font-size: 13px; cursor: pointer; padding: 8px; }
.section-heading { font-weight: 800; font-size: 15px; margin-bottom: 10px; font-family: 'Nunito', sans-serif; }

/* GATE MODAL */
.gate-overlay { position: fixed; inset: 0; background: rgba(26,46,74,0.5); z-index: 1000; display: flex; align-items: flex-end; justify-content: center; }
.gate-content { border-radius: 28px 28px 0 0; padding: 28px 24px 40px; width: 100%; max-width: 420px; box-shadow: 0 -8px 40px rgba(0,0,0,0.2); }
.gate-handle { width: 40px; height: 4px; border-radius: 2px; margin: 0 auto 24px; }
.gate-text { text-align: center; margin-bottom: 24px; }
.gate-icon { font-size: 52px; margin-bottom: 12px; }
.gate-text h3 { font-weight: 800; font-size: 20px; font-family: 'Nunito', sans-serif; margin-bottom: 8px; }
.gate-text p { font-size: 14px; line-height: 1.5; }
.gate-actions { display: flex; flex-direction: column; gap: 10px; }

/* BOTTOM NAV */
.bottom-nav { position: fixed; bottom: 0; left: 50%; transform: translateX(-50%); width: 100%; max-width: 420px; display: flex; box-shadow: 0 -4px 20px rgba(26,46,74,0.1); z-index: 100; }
.nav-btn { flex: 1; background: none; border: none; padding: 10px 2px 14px; cursor: pointer; display: flex; flex-direction: column; align-items: center; gap: 3px; position: relative; }
.nav-label { font-size: 9px; font-family: 'Nunito', sans-serif; }
.nav-indicator { width: 20px; height: 3px; border-radius: 2px; position: absolute; bottom: 6px; }

/* AD BANNERS */
.ad-banner { border-radius: 16px; padding: 14px 16px; margin: 14px 0; }
.ad-badge-wrap { display: flex; align-items: center; gap: 4px; margin-bottom: 8px; }
.ad-badge { font-size: 9px; background: rgba(0,0,0,0.07); padding: 2px 8px; border-radius: 20px; font-weight: 600; }
.ad-body { display: flex; align-items: center; gap: 12px; }
.ad-emoji { width: 46px; height: 46px; border-radius: 14px; background: rgba(255,255,255,0.7); display: flex; align-items: center; justify-content: center; font-size: 26px; flex-shrink: 0; }
.ad-info { flex: 1; }
.ad-info p { font-weight: 800; font-size: 14px; font-family: 'Nunito', sans-serif; }
.ad-info span { font-size: 12px; margin-top: 1px; display: block; }
.ad-btn { border: none; border-radius: 12px; padding: 8px 14px; color: white; font-size: 12px; font-weight: 700; cursor: pointer; white-space: nowrap; flex-shrink: 0; }

.ad-compact { border-radius: 14px; padding: 10px 14px; display: flex; align-items: center; gap: 10px; margin: 10px 0; }
.ad-compact-icon { font-size: 22px; flex-shrink: 0; }
.ad-compact-info { flex: 1; min-width: 0; }
.ad-compact-badge { font-size: 9px; background: rgba(0,0,0,0.06); padding: 1px 6px; border-radius: 8px; font-weight: 600; }
.ad-compact-info p { font-weight: 700; font-size: 12px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; margin-top: 2px; }
.ad-compact-info span { font-size: 10px; line-height: 1.3; display: block; }
.ad-compact-btn { border: none; border-radius: 10px; padding: 6px 10px; color: white; font-size: 10px; font-weight: 700; cursor: pointer; white-space: nowrap; flex-shrink: 0; }

/* AUTH SCREEN */
.auth-header { padding: 28px 20px 48px; position: relative; overflow: hidden; text-align: center; }
.auth-header-circle { position: absolute; top: -40px; right: -40px; width: 140px; height: 140px; border-radius: 50%; background: rgba(255,255,255,0.08); }
.auth-back-btn { position: absolute; left: 16px; top: 28px; background: rgba(255,255,255,0.2); border: none; color: white; border-radius: 10px; width: 34px; height: 34px; font-size: 18px; cursor: pointer; display: flex; align-items: center; justify-content: center; }
.auth-icon { font-size: 54px; margin-bottom: 10px; }
.auth-title { color: white; font-size: 22px; font-weight: 800; font-family: 'Nunito', sans-serif; }
.auth-subtitle { color: rgba(255,255,255,0.8); font-size: 13px; margin-top: 4px; }
.auth-content { padding: 0 20px; margin-top: -24px; position: relative; z-index: 2; }
.auth-tabs { padding: 6px; display: flex; gap: 4px; margin-bottom: 20px; }
.auth-tab-btn { flex: 1; border: none; border-radius: 14px; padding: 11px; font-weight: 700; font-size: 14px; cursor: pointer; transition: all 0.2s; font-family: 'Nunito', sans-serif; }
.step-indicator { display: flex; align-items: center; gap: 8px; margin-bottom: 20px; }
.step-item { display: flex; align-items: center; gap: 8px; }
.step-circle { width: 28px; height: 28px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-weight: 700; font-size: 12px; }
.step-label { font-size: 12px; }
.step-line { flex: 1; height: 2px; border-radius: 1px; }
.auth-card { padding: 20px; margin-bottom: 14px; }
.auth-section-title { font-weight: 700; font-size: 15px; font-family: 'Nunito', sans-serif; margin-bottom: 16px; }
.input-wrap { position: relative; margin-bottom: 12px; }
.input-icon { position: absolute; left: 14px; top: 50%; transform: translateY(-50%); font-size: 16px; }
.error-msg { font-size: 11px; color: #FF6B6B; margin-bottom: 8px; padding-left: 4px; }
.free-badge { border-radius: 12px; padding: 12px; margin-top: 4px; }
.free-badge p:first-child { font-size: 12px; font-weight: 600; }
.free-badge p:last-child { font-size: 11px; margin-top: 2px; }
.forgot-btn { background: none; border: none; font-size: 12px; cursor: pointer; padding: 4px 0; font-weight: 600; }
.auth-footer { text-align: center; margin-top: 10px; padding-bottom: 30px;}
.auth-footer p { font-size: 11px; line-height: 1.6; }

/* HOME SCREEN */
.screen-home { padding-bottom: 80px; }
.home-hero { padding: 24px 20px 60px; position: relative; overflow: hidden; }
.hero-circle { position: absolute; top: -40px; right: -40px; width: 160px; height: 160px; border-radius: 50%; background: rgba(255,255,255,0.08); }
.hero-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; }
.hero-greeting { color: rgba(255,255,255,0.75); font-size: 13px; margin-bottom: 2px; }
.hero-name { font-size: 20px; font-weight: 700; font-family: 'Nunito', sans-serif; }
.hero-btn-guest { background: rgba(255,255,255,0.2); border: 1.5px solid rgba(255,255,255,0.4); border-radius: 20px; padding: 6px 14px; font-size: 12px; font-weight: 700; cursor: pointer; }
.hero-avatar { width: 42px; height: 42px; border-radius: 50%; background: rgba(255,255,255,0.2); display: flex; align-items: center; justify-content: center; font-size: 20px; }
.baby-placeholder { background: rgba(255,255,255,0.12); border-radius: 16px; padding: 16px; border: 1.5px dashed rgba(255,255,255,0.35); text-align: center; cursor: pointer; }
.placeholder-title { color: rgba(255,255,255,0.9); font-weight: 700; font-size: 14px; font-family: 'Nunito', sans-serif; margin-bottom: 4px; }
.placeholder-sub { color: rgba(255,255,255,0.65); font-size: 12px; }
.baby-selector { display: flex; gap: 10px; }
.baby-tab { flex: 1; border-radius: 16px; padding: 12px 14px; cursor: pointer; }
.baby-tab-icon { font-size: 28px; margin-bottom: 4px; }
.baby-tab-name { font-weight: 700; font-size: 15px; font-family: 'Nunito', sans-serif; }
.baby-tab-age { font-size: 12px; }
.baby-add { width: 60px; background: rgba(255,255,255,0.12); border-radius: 16px; display: flex; align-items: center; justify-content: center; cursor: pointer; border: 1.5px dashed rgba(255,255,255,0.4); font-size: 22px; color: rgba(255,255,255,0.7); }
.home-content { padding: 0 16px; margin-top: -24px; position: relative; z-index: 2; }
.cta-card { padding: 18px 20px; margin-bottom: 12px; display: flex; align-items: center; gap: 14px; cursor: pointer; }
.cta-icon { width: 52px; height: 52px; border-radius: 16px; display: flex; align-items: center; justify-content: center; font-size: 24px; flex-shrink: 0; }
.cta-text { flex: 1; }
.cta-text p { font-weight: 700; font-size: 15px; font-family: 'Nunito', sans-serif; }
.cta-text span { font-size: 12px; margin-top: 2px; display: block; }
.cta-arrow { font-size: 22px; }
.vaccine-alert { border-radius: 16px; padding: 14px 16px; margin-bottom: 12px; display: flex; gap: 12px; align-items: center; }
.alert-icon { font-size: 26px; }
.alert-info { flex: 1; }
.alert-info p { font-weight: 700; font-size: 14px; font-family: 'Nunito', sans-serif; }
.alert-info span { font-size: 12px; }
.stats-grid { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 10px; margin-bottom: 18px; }
.stat-card { padding: 14px 10px; text-align: center; }
.stat-icon { font-size: 22px; margin-bottom: 4px; }
.stat-value { font-weight: 800; font-size: 14px; font-family: 'Nunito', sans-serif; }
.stat-label { font-size: 11px; }
.tools-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; margin-bottom: 6px; }
.tool-card { border-radius: 20px; cursor: pointer; }
.tool-lock { position: absolute; top: 8px; right: 8px; font-size: 12px; }
.tool-icon { font-size: 28px; margin-bottom: 6px; }
.tool-title { font-weight: 700; font-size: 13px; font-family: 'Nunito', sans-serif; }
.tool-sub { font-size: 11px; margin-top: 2px; }
.articles-list { display: flex; flex-direction: column; gap: 10px; }
.article-card { cursor: pointer; }
.article-icon { font-size: 30px; }
.article-info { flex: 1; }
.article-info p { font-weight: 600; font-size: 13px; line-height: 1.4; }
.article-info div { display: flex; gap: 8px; margin-top: 4px; align-items: center; }
.article-tag { font-size: 10px; padding: 2px 8px; border-radius: 20px; font-weight: 600; }
.article-time { font-size: 11px; }

/* CHAT SCREEN */
.screen-chat { padding-bottom: 80px; height: 100%; display: flex; flex-direction: column; }
.chat-guest-hero { padding: 24px 20px 40px; margin: 0 -16px 24px; }
.chat-guest-hero h2 { font-size: 20px; font-weight: 800; font-family: 'Nunito', sans-serif; margin-bottom: 4px; }
.chat-guest-hero p { font-size: 13px; }
.chat-guest-icon { font-size: 50px; margin-bottom: 12px; }
.chat-active-wrap { display: flex; flex-direction: column; height: 100%; }
.chat-header { padding: 12px 16px; display: flex; align-items: center; gap: 12px; }
.chat-back { position: static; width: 34px; height: 34px; border-radius: 10px; display: flex; align-items: center; justify-content: center; }
.chat-avatar { width: 36px; height: 36px; border-radius: 50%; background: rgba(255,255,255,0.25); display: flex; align-items: center; justify-content: center; font-size: 18px; }
.chat-header-info { flex: 1; }
.chat-header-info p { font-weight: 700; font-size: 14px; font-family: 'Nunito', sans-serif; }
.chat-header-info span { font-size: 11px; }
.chat-messages { flex: 1; overflow-y: auto; padding: 16px; display: flex; flex-direction: column; gap: 12px; }
.chat-bubble-wrap { display: flex; align-items: flex-end; gap: 8px; }
.chat-bot-icon { width: 30px; height: 30px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 14px; flex-shrink: 0; }
.chat-bubble { max-width: 78%; padding: 12px 14px; font-size: 13px; line-height: 1.55; box-shadow: 0 2px 8px rgba(0,0,0,0.08); white-space: pre-wrap; }
.chat-input-area { padding: 12px 16px; display: flex; gap: 10px; align-items: center; }
.chat-input-area input { flex: 1; border-radius: 24px; padding: 10px 16px; font-size: 14px; outline: none; font-family: 'Nunito', sans-serif; }
.chat-input-area button { width: 44px; height: 44px; border-radius: 50%; border: none; font-size: 18px; display: flex; align-items: center; justify-content: center; transition: all 0.2s; }
.chat-history-hero { padding: 24px 20px 32px; }
.chat-history-hero h2 { font-size: 20px; font-weight: 800; font-family: 'Nunito', sans-serif; margin-bottom: 4px; }
.chat-history-hero p { font-size: 13px; }
.chat-history-content { padding: 16px; }
.history-list { display: flex; flex-direction: column; gap: 10px; }
.history-card { cursor: pointer; }
.history-card-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 6px; }
.history-card-header span:first-child { font-size: 11px; padding: 3px 10px; border-radius: 20px; font-weight: 600; }
.history-card p { font-weight: 700; font-size: 14px; font-family: 'Nunito', sans-serif; }

/* TYPING ANIMATION */
.typing { padding: 14px 18px !important; display: flex; gap: 4px; }
.typing-dot { width: 7px; height: 7px; border-radius: 50%; animation: bounce 1s infinite; }
@keyframes bounce { 0%, 100% { transform: translateY(0) } 50% { transform: translateY(-5px) } }

/* VACCINES SCREEN */
.screen-vaccines { padding-bottom: 80px; }
.vac-hero { padding: 24px 20px 32px; }
.vac-hero h2 { font-size: 20px; font-weight: 800; font-family: 'Nunito', sans-serif; margin-bottom: 4px; }
.vac-hero p { font-size: 13px; }
.vac-stats { display: flex; gap: 14px; margin-top: 16px; }
.vac-stat { background: rgba(255,255,255,0.15); border-radius: 12px; padding: 10px 18px; text-align: center; }
.vac-stat p { font-weight: 800; font-size: 22px; }
.vac-stat span { font-size: 11px; }
.vac-progress-wrap { flex: 1; background: rgba(255,255,255,0.15); border-radius: 12px; padding: 10px 14px; display: flex; flex-direction: column; justify-content: center; }
.vac-bar-bg { height: 6px; background: rgba(255,255,255,0.2); border-radius: 3px; overflow: hidden; }
.vac-bar-fill { height: 100%; border-radius: 3px; }
.vac-progress-wrap p { font-size: 11px; margin-top: 4px; }
.vac-list { padding: 16px; display: flex; flex-direction: column; gap: 10px; }
.vac-icon { width: 42px; height: 42px; border-radius: 12px; display: flex; align-items: center; justify-content: center; font-size: 20px; }
.vac-info { flex: 1; }
.vac-info p { font-weight: 700; font-size: 14px; font-family: 'Nunito', sans-serif; }
.vac-info span { font-size: 12px; }
.vac-badge { font-size: 10px; padding: 3px 10px; border-radius: 20px; font-weight: 700; }

/* CENTERS SCREEN */
.screen-centers { padding-bottom: 80px; }
.centers-detail { }
.center-map-mock { position: relative; height: 200px; overflow: hidden; }
.center-marker-wrap { position: absolute; top: 38%; left: 47%; transform: translate(-50%, -50%); text-align: center; }
.center-marker-pin { width: 44px; height: 44px; border-radius: 50% 50% 50% 0; transform: rotate(-45deg); display: flex; align-items: center; justify-content: center; margin: 0 auto; }
.center-marker-icon { transform: rotate(45deg); font-size: 20px; }
.center-marker-label { margin-top: 4px; background: #fff; border-radius: 8px; padding: 4px 10px; font-size: 11px; font-weight: 700; box-shadow: 0 2px 8px rgba(0,0,0,0.15); }
.center-user-dot { position: absolute; top: 62%; left: 28%; width: 14px; height: 14px; border-radius: 50%; border: 3px solid white; box-shadow: 0 0 0 4px rgba(59,130,246,0.3); }
.center-back-btn { position: absolute; top: 16px; left: 16px; background: white; border: none; border-radius: 12px; width: 38px; height: 38px; font-size: 18px; cursor: pointer; display: flex; align-items: center; justify-content: center; box-shadow: 0 2px 12px rgba(0,0,0,0.15); }
.center-dist-badge { position: absolute; top: 16px; right: 16px; background: white; border-radius: 20px; padding: 6px 12px; font-weight: 700; font-size: 12px; box-shadow: 0 2px 12px rgba(0,0,0,0.15); }
.center-info-area { padding: 0 16px; }
.center-main-card { padding: 18px; margin-top: -20px; margin-bottom: 14px; position: relative; z-index: 2; }
.center-main-header { display: flex; gap: 12px; align-items: flex-start; }
.center-icon { width: 50px; height: 50px; border-radius: 14px; display: flex; align-items: center; justify-content: center; font-size: 26px; flex-shrink: 0; }
.center-title-area { flex: 1; }
.center-tags { display: flex; gap: 6px; flex-wrap: wrap; margin-bottom: 6px; }
.c-tag { font-size: 10px; padding: 3px 9px; border-radius: 20px; font-weight: 700; }
.center-title-area h3 { font-weight: 800; font-size: 16px; font-family: 'Nunito', sans-serif; line-height: 1.3; margin-bottom: 4px; }
.center-stats-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; margin-bottom: 14px; }
.c-stat-card { padding: 12px 14px; display: flex; gap: 10px; align-items: center; }
.c-stat-icon { font-size: 20px; }
.c-stat-label { font-size: 11px; }
.c-stat-val { font-weight: 700; font-size: 13px; }
.center-services-card { padding: 16px; margin-bottom: 14px; }
.c-srv-title { font-weight: 700; font-size: 14px; font-family: 'Nunito', sans-serif; margin-bottom: 10px; }
.c-srv-list { display: flex; flex-wrap: wrap; gap: 8px; }
.c-srv-item { font-size: 12px; padding: 6px 12px; border-radius: 20px; font-weight: 600; }
.center-actions { display: flex; gap: 10px; margin-bottom: 14px; }
.c-btn-call { flex: 1; border-radius: 16px; padding: 14px; color: white; font-weight: 700; font-size: 14px; text-decoration: none; display: flex; align-items: center; justify-content: center; gap: 8px; }
.c-btn-map { flex: 1; border-radius: 16px; padding: 14px; font-weight: 700; font-size: 14px; cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 8px; }

.centers-hero { padding: 24px 20px 32px; position: relative; overflow: hidden; }
.centers-hero h2 { font-size: 20px; font-weight: 800; font-family: 'Nunito', sans-serif; margin-bottom: 4px; }
.centers-hero p { font-size: 13px; }
.centers-list-area { padding: 0 16px; margin-top: -20px; position: relative; z-index: 2; }
.c-map-mock-small { height: 140px; margin-bottom: 14px; position: relative; overflow: hidden; background: linear-gradient(135deg,#DBEAFE,#EDE9FE); }
.c-user-dot { position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%); width: 14px; height: 14px; border-radius: 50%; border: 2px solid white; box-shadow: 0 0 0 4px rgba(59,130,246,0.3); }
.c-user-label { position: absolute; bottom: 10px; left: 50%; transform: translateX(-50%); background: white; border-radius: 20px; padding: 5px 14px; font-size: 11px; font-weight: 700; box-shadow: 0 2px 8px rgba(0,0,0,0.15); white-space: nowrap;}
.c-emergencies { border-radius: 16px; padding: 14px 16px; margin-bottom: 14px; }
.c-emerg-title { font-weight: 800; font-size: 14px; font-family: 'Nunito', sans-serif; margin-bottom: 8px; }
.c-emerg-item { display: flex; justify-content: space-between; align-items: center; cursor: pointer; margin-bottom: 6px; }
.c-filters { display: flex; gap: 8px; overflow-x: auto; padding-bottom: 4px; margin-bottom: 14px; }
.c-filter-btn { border-radius: 24px; padding: 8px 14px; font-weight: 600; font-size: 12px; cursor: pointer; white-space: nowrap; font-family: 'Nunito', sans-serif; }
.c-list { display: flex; flex-direction: column; gap: 12px; }
.c-list-item { padding: 16px; cursor: pointer;}
.c-list-header { display: flex; gap: 14px; align-items: flex-start; }
.c-list-icon { width: 50px; height: 50px; border-radius: 14px; display: flex; align-items: center; justify-content: center; font-size: 24px; flex-shrink: 0; }
.c-list-info { flex: 1; }
.c-list-title-row { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 4px; }
.c-list-title-row p { font-weight: 800; font-size: 14px; font-family: 'Nunito', sans-serif; line-height: 1.3; flex: 1; padding-right: 8px; }
.c-list-dist { text-align: right; flex-shrink: 0; }
.c-list-dist span:first-child { font-weight: 700; font-size: 13px; display: block; }
.c-list-dist span:last-child { font-size: 11px; }
.c-list-address { font-size: 12px; margin-bottom: 8px; }
.c-list-tags { display: flex; gap: 6px; flex-wrap: wrap; align-items: center; }
.c-list-tags span { font-size: 10px; padding: 2px 8px; border-radius: 12px; font-weight: 700; }
.c-list-rating { margin-left: 2px; }
.c-list-actions { margin-top: 12px; padding-top: 12px; display: flex; gap: 8px; }
.c-list-btn { flex: 1; border-radius: 10px; padding: 8px; text-align: center; font-weight: 700; font-size: 12px; }

/* PROFILE SCREEN */
.screen-profile { padding-bottom: 80px; }
.prof-guest-hero { padding: 24px 20px 48px; margin: 0 -16px 0; text-align: center; }
.prof-guest-icon { font-size: 60px; margin-bottom: 10px; }
.prof-guest-hero h2 { font-size: 20px; font-weight: 800; font-family: 'Nunito', sans-serif; }
.prof-guest-content { padding: 0 16px; margin-top: -20px; position: relative; z-index: 2; }
.prof-upsell-card { padding: 20px; margin-bottom: 14px; text-align: center; }
.prof-upsell-card p { font-weight: 700; font-size: 15px; margin-bottom: 16px; font-family: 'Nunito', sans-serif; }
.prof-upsell-item { display: flex; align-items: center; gap: 10px; margin-bottom: 10px; text-align: left; }
.prof-check { width: 22px; height: 22px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 12px; font-weight: 700; flex-shrink: 0; }

.prof-hero { padding: 24px 20px 50px; margin: 0 -16px 0; position: relative; overflow: hidden; }
.prof-hero-circle { position: absolute; top: -30px; right: -30px; width: 120px; height: 120px; border-radius: 50%; background: rgba(255,255,255,0.06); }
.prof-hero-main { display: flex; align-items: center; gap: 16px; }
.prof-avatar { width: 62px; height: 62px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 28px; border: 3px solid rgba(255,255,255,0.3); }
.prof-hero-info { flex: 1; }
.prof-hero-info h2 { color: white; font-size: 20px; font-weight: 800; font-family: 'Nunito', sans-serif; }
.prof-hero-tags { display: flex; gap: 6px; margin-top: 6px; }
.p-tag-free { background: rgba(255,255,255,0.15); color: white; font-size: 10px; padding: 3px 10px; border-radius: 20px; font-weight: 600; }
.p-tag-role { color: #A7F3D0; font-size: 10px; padding: 3px 10px; border-radius: 20px; font-weight: 600; }
.prof-edit-btn { background: rgba(255,255,255,0.15); border: 1px solid rgba(255,255,255,0.3); color: white; border-radius: 12px; padding: 8px 14px; font-size: 12px; font-weight: 600; cursor: pointer; }

.prof-content { padding: 0 16px; margin-top: -24px; position: relative; z-index: 2; }
.prof-premium-card { border-radius: 20px; padding: 16px 18px; margin-bottom: 14px; display: flex; align-items: center; gap: 14px; border: 1px solid rgba(255,255,255,0.1); }
.p-prem-icon { font-size: 30px; }
.p-prem-info { flex: 1; }
.p-prem-info p { font-weight: 800; font-size: 14px; font-family: 'Nunito', sans-serif; }
.p-prem-btn { border: none; border-radius: 12px; padding: 8px 14px; color: white; font-weight: 700; font-size: 12px; cursor: pointer; white-space: nowrap; }

.prof-section-card { padding: 20px; margin-bottom: 14px; }
.prof-section-title { font-weight: 800; font-size: 15px; font-family: 'Nunito', sans-serif; margin-bottom: 16px; }
.prof-field { margin-bottom: 12px; }
.prof-field label { font-size: 11px; font-weight: 600; margin-bottom: 4px; display: block; }
.prof-input { width: 100%; border-radius: 12px; padding: 10px 14px; font-size: 14px; outline: none; font-family: 'Nunito', sans-serif; box-sizing: border-box; }
.prof-val { font-size: 14px; font-weight: 600; padding: 10px 0; }

.prof-pref-item { display: flex; align-items: center; gap: 14px; margin-bottom: 14px; }
.prof-pref-info { flex: 1; }
.prof-pref-info p { font-weight: 600; font-size: 13px; }
.prof-pref-info span { font-size: 11px; margin-top: 2px; display: block; }
.toggle-switch { width: 46px; height: 26px; border-radius: 13px; position: relative; cursor: pointer; transition: all 0.2s; }
.toggle-knob { position: absolute; top: 2px; width: 18px; height: 18px; border-radius: 50%; background: white; transition: all 0.2s; box-shadow: 0 1px 4px rgba(0,0,0,0.2); }

.prof-actions-card { padding: 16px; margin-bottom: 14px; }
.prof-action-item { display: flex; align-items: center; gap: 12px; padding: 12px 0; cursor: pointer; }
.pa-icon { font-size: 20px; }
.pa-label { flex: 1; font-weight: 600; font-size: 14px; }
.pa-arrow { font-size: 18px; }

.logout-btn { width: 100%; border-radius: 16px; padding: 14px; font-weight: 700; font-size: 14px; cursor: pointer; font-family: 'Nunito', sans-serif; }
</style>